export var getMaskedString = function (string) {
    var lenght = string.length > 8 ? string.length - 8 : 0;
    var firstPart = string.slice(0, 4);
    var lastPart = string.slice(-4);
    return firstPart + "(" + lenght + ")" + lastPart;
};
